import { useState } from "react";
import Chart from "react-apexcharts";
import { ApexOptions } from "apexcharts";

export interface IChartData {
  name: string;
  data: number[];
}

export interface IChartOptions {
  series: IChartData[];
  categories: string[];
}

const CollectionReportView = () => {
  type ViewOption = "Today" | "Month" | "Year";
  const [selectedView, setSelectedView] = useState<ViewOption>("Today");

  const data: Record<ViewOption, IChartOptions> = {
    Today: {
      series: [
        {
          name: "Today",
          data: [30, 20, 40, 60, 10, 40, 50, 66, 77, 12, 80, 56],
        },
      ],
      categories: [
        "12:00 AM",
        "1:00 AM",
        "2:00 AM",
        "3:00 AM",
        "4:00 AM",
        "5:00 AM",
        "6:00 AM",
        "7:00 AM",
        "8:00 AM",
        "9:00 AM",
        "10:00 AM",
        "11:00 AM",
      ],
    },
    Month: {
      series: [
        {
          name: "Month",
          data: [20, 30, 25, 45, 50, 60, 40],
        },
      ],
      categories: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
    },
    Year: {
      series: [
        {
          name: "Year",
          data: [300, 450, 200, 500, 700, 600],
        },
      ],
      categories: ["2019", "2020", "2021", "2022", "2023", "2024"],
    },
  };

  const chartOptions: ApexOptions = {
    chart: {
      id: "line-chart",
      toolbar: {
        show: true,
      },
    },
    xaxis: {
      categories: data[selectedView].categories,
    },
    dataLabels: {
      enabled: false,
      style: {
        fontSize: "12px",
        colors: ["#000"],
      },
    },
    stroke: {
      curve: "smooth",
    },
    markers: {
      size: 5,
    },
    tooltip: {
      enabled: true,
    },
  };

  return (
    <div>
      <div className="flex justify-center gap-4 my-4">
        <button
          onClick={() => setSelectedView("Today")}
          className={`px-4 py-2 rounded ${
            selectedView === "Today"
              ? "bg-accent-emphasis text-on-accent"
              : "bg-inset text-default"
          } hover:bg-accent-muted`}
        >
          Today
        </button>
        <button
          onClick={() => setSelectedView("Month")}
          className={`px-4 py-2 rounded ${
            selectedView === "Month"
              ? "bg-accent-emphasis text-on-accent"
              : "bg-inset text-default"
          } hover:bg-accent-muted`}
        >
          Month
        </button>
        <button
          onClick={() => setSelectedView("Year")}
          className={`px-4 py-2 rounded ${
            selectedView === "Year"
              ? "bg-accent-emphasis text-on-accent"
              : "bg-inset text-default"
          } hover:bg-accent-muted`}
        >
          Year
        </button>
      </div>
      <Chart
        options={chartOptions}
        series={data[selectedView].series}
        type="line"
        height={350}
      />
    </div>
  );
};

export default CollectionReportView;
